import { createUseStyles } from 'react-jss';
import { Spacings } from '@picsart/design-system/foundation/spacings';
import { BreakPoints } from '@picsart/design-system/foundation/responsive';
import { mediaQuery } from '@picsart/rc/helpers';
import { FontSizes, LineHeights } from '@picsart/design-system/foundation/typography';

const useStyles = createUseStyles<
  string,
  { gradientColor: string; gradientColor2: string; isStartScreen: boolean }
>(
  {
    root: {
      position: 'relative',
      textAlign: 'center',
      width: '100%',
      marginTop: params => (params?.isStartScreen ? Spacings.s0 : Spacings.s32),
    },
    background: {
      height: 388,
      width: '74vw',
      position: 'absolute',
      top: '43%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      background: colors =>
        `linear-gradient(60.72deg, ${colors?.gradientColor || '#0E00AC'} -11%, ${
          colors?.gradientColor2 || '#FF34F9'
        } 86.67%)`,
      borderRadius: '47%',
      opacity: 0.4,
      filter: 'blur(80px)',
      '@media screen and (max-width: 767px)': {
        height: 368,
        width: '100vw',
        top: 372,
      },
    },

    title: {
      display: 'flex',
      justifyContent: 'center',
      marginBottom: Spacings.s16,
      '&& p': {
        maxWidth: 1064,
      },
      [mediaQuery(BreakPoints.Small)]: {
        fontSize: FontSizes.s30,
        lineHeight: LineHeights.l48,
      },
    },

    description: {
      maxWidth: 1072,
      marginBottom: Spacings.s32,
      marginInline: 'auto',
      paddingLeft: Spacings.s4,
      paddingRight: Spacings.s4,
      textAlign: 'align',
    },

    widgetContainer: {
      marginInline: 'auto',
      position: 'relative',
    },

    centeredWidgetContainer: {
      position: 'relative',
      margin: '0 auto',
    },

    leftImg: {
      width: 194,
      borderRadius: Spacings.s24,
      left: 120,
      position: 'absolute',
      top: Spacings.s24,
      rotate: '-15deg',
      boxShadow: ' 0px 0px 22.2478px rgba(0, 0, 0, 0.24)',
      '@media(min-width: 1280px)': {
        left: 0,
      },
    },

    topRightImg: {
      width: 100,
      borderRadius: Spacings.s12,
      rotate: '-15deg',
      right: 112,
      position: 'absolute',
      top: Spacings.s16,
      boxShadow: ' 0px 0px 22.2478px rgba(0, 0, 0, 0.24)',
      '@media(min-width: 1280px)': {
        right: Spacings.s12,
      },
    },

    bottomRightImg: {
      width: 140,
      borderRadius: Spacings.s12,
      rotate: '15deg',
      bottom: -80,
      right: 200,
      position: 'absolute',
      boxShadow: ' 0px 0px 22.2478px rgba(0, 0, 0, 0.24)',
      '@media(min-width: 1280px)': {
        right: Spacings.s64,
      },
    },

    hideOnMobile: {
      '&&': {
        '@media screen and (max-width: 1280px)': {
          display: 'none',
        },
      },
    },
    choicesContainer: {
      display: 'flex',
      justifyContent: 'center',
      marginBottom: Spacings.s64,
    },
  },
  {
    name: 'WidgetExperiment',
  },
);

export default useStyles;
